import { UserProfile } from './user-profile';
import { UserGroup } from './user-group';

export class User {
  id?: number;
  avatar: string;
  comment_moderator: boolean;
  edition_admin: boolean;
  edition_admin_analytics: boolean;
  resource_editor: boolean;
  community_expert: boolean;
  require_payment: boolean;
  email: string;
  active: boolean;
  disable_all_emails: boolean;
  first_name: string;
  last_name: string;
  potential_admin: boolean;
  profile: UserProfile[];
  registered: string;
  created: string;
  can_change_password: boolean;
  password?: string;
  groups: UserGroup[];
  subscriptions: any[];
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/models/program/user.ts